import { calculateCharLength } from '@salescore/frontend-common'
import { type GetRef, InputNumber } from 'antd'
import { type ReactElement, useRef, useState } from 'react'

import type { RSheetColumn, RSheetRecordNode } from '../../../../../domain/column.ts'
import { useCursorModel } from '../../../../../recoil/cursor'
import { useUpsertSheetRowMutation } from '../../../../recoil/mutations/upsertSheetRowMutation'
import { getHeaderColor } from '../../../header/RSheetsNodeBlockHeader'
import type { RSheetsCellInputRenderTypeArgument } from '../rSheetsCellInputRenderTypeArgument'
import { RSheetsInputCellWrapper } from './InputCellWrapper'

const castToNumber = (value: unknown): number => {
  if (typeof value === 'string') {
    const number_ = Number(value)
    return Number.isNaN(number_) ? 0 : number_
  } else if (typeof value === 'number') {
    return value
  }
  return 0
}

export function RSheetsCellNumberInput({
  recordNode,
  column,
  rowIndex,
  innerRowIndex,
  defaultWidth,
  finishEditMode,
  boxStyle,
  columns,
  compiledConfig,
  ability,
  query,
}: RSheetsCellInputRenderTypeArgument & { columns: Array<RSheetColumn<RSheetRecordNode>> }): ReactElement {
  const cursor = useCursorModel(columns)
  const columnOnChange = useUpsertSheetRowMutation(recordNode, ability, query)
  const rawInitialValue =
    cursor?.editing?.initialPressedKey ?? (recordNode === undefined ? undefined : column.value(recordNode))
  const initialValue = castToNumber(rawInitialValue)
  const [value, setValue] = useState(initialValue)
  const reference = useRef<GetRef<typeof InputNumber>>(null)

  // eslint-disable-next-line react-hooks/refs
  setTimeout(() => {
    if (reference.current !== null) {
      reference.current.focus()
    }
  }, 1)

  return RSheetsInputCellWrapper(
    {
      onChangeFixed: () => {
        void columnOnChange({ value, rowIndex, innerRowIndex, column })
      },
      finishEditMode,
    },
    ({ handleKeyDown }) => (
      <div
        style={{
          ...boxStyle,
          // Spreadsheetと似たロジックで、中身の文字列が増えたら幅を広げて全部表示させる。
          // 他のセルの位置に影響を与えずこれを実現するため、position: absoluteにして実現している
          width: Math.max(defaultWidth, calculateCharLength(value.toString()) * 10),
          padding: '4px 8px', // padingYはボーダーにかぶらなければなんでも良い
          marginTop: 1, // これがないと1pxずれるが、Cell側と比べてなぜ1px分の差があるのか不明
          marginLeft: 1,
          // boxShadow: '1px 4px 7px 2px rgb(60 64 67 / 15%)',
        }}
      >
        <InputNumber
          ref={reference}
          variant="outlined"
          value={value}
          onChange={(value) => {
            setValue(value ?? 0)
          }}
          onKeyDown={(event) => {
            handleKeyDown(event)
          }}
          style={{
            // backgroundColor: 'white',
            backgroundColor: getHeaderColor(column.color).cellColor,
            padding: 0,
            width: '100%',
            height: '100%', // 複数行にしたい場合は対応が必要
            // width: Math.max(defaultWidth - 20, calculateCharLength(value as string) * 10)
            // width: 400,
          }}
        />
      </div>
    ),
  )
}
